export enum IntegrationStatuses {
  AvailableForCustomers = 3258,
  Discontinued = 3260,
  InDevelopment = 3266,
  InReview = 3256,
  Rejected = 3261,
  NotStarted = 4090,
}
